import { connect } from 'react-redux';
import { getAEOptions } from 'selectors/options';
import SelectOptionField from './SelectOptionField';


const mapStateToProps = (state) => {
  return {
    name: 'ae',
    label: 'AE',
    options: getAEOptions(state),
  }
}

export default connect(
  mapStateToProps,
)(SelectOptionField);

